import React from "react";
import { Select, SelectItem } from "carbon-components-react";

import {
  AppraisalReportFormNumberEnum,
  LevelOfPropertyReviewEnum,
  AppraisalReportFormNumberDisplayValues,
  LevelOfPropertyReviewDisplayValues,
} from "@eave/shared/types/api";

const styles = require("underwriter_dashboard/hurdle_editors/styles.module.scss");

interface AppraisalFieldsProps {
  levelOfPropertyReview: string;
  appraisalReportFormNumber: string;
  setLevelOfPropertyReview: Function;
  setAppraisalReportFormNumber: Function;
}

const AppraisalFields = ({
  appraisalReportFormNumber,
  levelOfPropertyReview,
  setLevelOfPropertyReview,
  setAppraisalReportFormNumber,
}: AppraisalFieldsProps) => (
  <>
    <div className={styles.title}>
      <h4>1008 appraisal fields</h4>
      <p>
        The following dropdown selections below will propagate onto the 1008 Fannie Mae form in
        regards to appraisal information for Level of Property Review and Form Number respectively
        in the underwriting package disclosure.
      </p>
    </div>

    <table className="table">
      <thead>
        <tr>
          <th className="col-lg-2">Source</th>
          <th className="col-lg-2">PropertyType</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Level of Property Review</td>
          <td>
            <Select
              id="level_of_property_type"
              name="level_of_property_type"
              value={levelOfPropertyReview}
              onChange={setLevelOfPropertyReview}
            >
              <SelectItem text="Select..." value="" />
              {Object.values(LevelOfPropertyReviewEnum)?.map(v => (
                <SelectItem key={v} value={v} text={LevelOfPropertyReviewDisplayValues[v]} />
              ))}
            </Select>
          </td>
        </tr>
        <tr>
          <td>Appraisal Report Form Number</td>
          <td>
            <Select
              id="appraisal_report_form_number"
              name="appraisal_report_form_number"
              value={appraisalReportFormNumber}
              onChange={setAppraisalReportFormNumber}
            >
              <SelectItem text="Select..." value="" />
              {Object.values(AppraisalReportFormNumberEnum)?.map(v => (
                <SelectItem key={v} value={v} text={AppraisalReportFormNumberDisplayValues[v]} />
              ))}
            </Select>
          </td>
        </tr>
      </tbody>
    </table>
  </>
);

export default AppraisalFields;
